export * from "./getAppVersion";
